/* eslint-disable */
import PropTypes from 'prop-types';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const KeyValuePairsPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The fields mapping array with the following entries:
   * Example:
   * [`details.deliveryAddress`, `OrderService.OrderDetails.Labels.DeliveryAddress`]
   *
   * A transform function can be provided.
   * Example:
   * [`details.cancelledAt`, `OrderService.OrderDetails.Labels.OrderCancelled`, (date) => format(date, `h:m a, ddd D MMM YYYY`)]
   */
  fieldsMapping: PropTypes.arrayOf(PropTypes.array).isRequired,

  /**
   * The key value pairs
   */
  keyValuePairs: PropTypes.object.isRequired,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,
};

export default KeyValuePairsPropTypes;
